import { Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { Button } from '@/components/form/baseInputs/Button';
import { Upload01Icon } from '@/components/icons/Upload01Icon';
import { DataTableCard } from '@/components/tables/DataTable/components/DataTableCard';
import { useRequiredParam } from '@/hooks/useRequiredParam';
import { DocumentsTable } from '@/modules/documents/DocumentsTable/DocumentsTable';
import { MultiDocumentUploaderProvider } from '@/modules/documents/MultiDocumentUploader/context/MultiDocumentUploader.provider';
import { useEntityDetailsContext } from '@/modules/entities/contexts/entityDetails/entityDetails.context';
import { DocumentWhereInput } from '@/types/schema';

function getDocumentsLike(
  entityId: string,
  householdId: string
): DocumentWhereInput {
  return {
    hasHouseholdWith: [{ id: householdId }],
    or: [{ hasEntityDocumentRelationshipsWith: [{ entityID: entityId }] }],
  };
}

export function EntityDocumentsPage() {
  const householdId = useRequiredParam('householdId');
  const entityId = useRequiredParam('entityId');
  const { entityType } = useEntityDetailsContext();

  const [createDocumentModalOpen, setCreateDocumentModalOpen] = useState(false);

  return (
    <MultiDocumentUploaderProvider>
      <Stack height="100%" spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="title-l" component="h2">
            Documents
          </Typography>
          <Button
            size="sm"
            onClick={() => setCreateDocumentModalOpen(true)}
            variant="primary"
            startIcon={Upload01Icon}
          >
            Upload documents
          </Button>
        </Stack>
        <DataTableCard sx={{ height: 'auto' }}>
          <DocumentsTable
            householdId={householdId}
            entityId={entityId}
            entityType={entityType}
            createDocumentModalOpen={createDocumentModalOpen}
            handleCreateDocumentModalClose={() =>
              setCreateDocumentModalOpen(false)
            }
            documentsLike={getDocumentsLike(entityId, householdId)}
            variant="entity-documents"
          />
        </DataTableCard>
      </Stack>
    </MultiDocumentUploaderProvider>
  );
}
